// Components==============
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spark from 'components/UI/Spark/Spark';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { SkillModalContext } from '../SkillModal/SkillModal';
import './SparkGroup.module.scss';
// =========================

export default function SparkGroup({
  group,
  value,
}: {
  group: SparkEntity[];
  value: string;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const { selectedSparks, setSelectedSparks } = useContext(SkillModalContext);

  const selectedCount = group.filter(
    (spark) => selectedSparks?.find((s) => s.id === spark.id) !== undefined
  ).length;

  useEffect(() => {
    if (!value) setIsOpen(false);
    if (value) setIsOpen(true);
  }, [value]);

  const handleSparkAdd = (spark: SparkEntity) => {
    if (spark.related_sparks) {
      setSelectedSparks((prev) => [...prev, spark, ...spark.related_sparks]);
    } else {
      setSelectedSparks((prev) => [...prev, spark]);
    }
  };
  const handleSparkRemove = (spark: SparkEntity) => {
    if (spark.related_sparks) {
      const allIds = [spark.id, ...spark.related_sparks.map((s) => s.id)];
      setSelectedSparks((prev) => prev.filter((s) => !allIds.includes(s.id)));
    } else {
      setSelectedSparks((prev) => prev.filter((s) => s.id !== spark.id));
    }
  };

  return (
    <motion.div styleName="group-wrapper" {...framerFade}>
      <div
        styleName={`${isOpen ? 'is-open' : ''} heading `}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <p>
          {group[0].heading} {!!selectedCount && <span>({selectedCount})</span>}
        </p>
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div styleName="sparks " {...framerFade}>
            {group.map((spark) => {
              const sparkSelected =
                selectedSparks?.find((s) => s.id === spark?.id) !== undefined;

              return (
                !!spark && (
                  <Spark
                    spark={spark}
                    key={spark?.id}
                    onClick={() =>
                      sparkSelected
                        ? handleSparkRemove(spark)
                        : handleSparkAdd(spark)
                    }
                    grey={!sparkSelected}
                  />
                )
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
